import { useCallback } from 'react';
import { bridge } from 'shared/src/utils';
import { getGoodsListScreen } from '../utils/getGoodsListScreen';

type Params = {
  type: string;
  listId: string | undefined;
};

export const useLogClickDeliveryToggle = (params: Params) => {
  return useCallback(
    (isOn: boolean) => {
      bridge.logAnalyticsEvent({
        name: 'CLICK_HEADLINE_XSMALL_ONE_LINE_TOGGLE',
        analytics: {
          SCREEN: getGoodsListScreen(params.type),
          IS_ON: isOn,
          LIST_ID: params.listId,
          TOGGLE_TYPE: 'today',
        },
      });
    },
    [params.type, params.listId],
  );
};
